import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiAppBar = (baseTheme: Theme): Partial<Components> => ({
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: baseTheme.palette.common.white,
        color: baseTheme.palette.text.primary,
        borderBottom: `1px solid ${baseTheme.palette.border}`,
        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
      },
    },
  },
});
